import React from 'react';

const AnswerControls = ({ teams, onTeamAnswered, onNoAnswer }) => {
  return (
    <div className="text-center">
      <p className="text-lg font-bold text-purple-700 mb-4">من أجاب بشكل صحيح؟</p>
      <div className="answer-controls-container">
        {teams.map((team, index) => (
          <button
            key={index}
            onClick={() => onTeamAnswered(index)}
            className="answer-button"
          >
            {team.name}
          </button>
        ))}
      </div>
      <button onClick={onNoAnswer} className="no-answer-button">
        لم يجب أحد
      </button>
    </div>
  );
};

export default AnswerControls;
